<script setup lang="ts">
import { Element, ToggleButton, WepinTypes } from 'wepin-vue-component'

type PropsElementType = {
  name: WepinTypes.ElementName
  size: string
  color: string
}
type PropsButtonType = ButtonElement | ButtonToggle
type ButtonElement = PropsElementType & {
  type: 'element'
}
type ButtonToggle = {
  type: 'toggle'
  checked: boolean
  color: string
  disabled: boolean
}

defineProps<{
  element?: PropsElementType
  name: string
  desc?: string
  button?: PropsButtonType
}>()
const emit = defineEmits<{
  (event: 'click'): void
  (event: 'update:check', checked: boolean): void
  (event: 'click:button'): void
}>()

const onToggleUpdateCheck = (checked: boolean) => {
  emit('update:check', checked)
}
</script>

<template>
  <div class="popup-list-item" @click="emit('click')">
    <div v-if="element" class="item-icon">
      <Element
        :name="element.name"
        :size="element.size"
        :color="element.color"
      />
    </div>
    <div class="item-name">
      {{ name }}
      <span v-if="desc" class="item-desc">{{ desc }}</span>
    </div>
    <div class="item-button">
      <template v-if="button">
        <Element
          v-if="button.type === 'element'"
          :name="button.name"
          :color="button.color"
          :size="button.size"
          @click="emit('click:button')"
        />
        <ToggleButton
          v-else-if="button.type === 'toggle'"
          :checked="button.checked"
          :color="button.color"
          :disabled="button.disabled"
          @update:checked="onToggleUpdateCheck"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'wepin-vue-component/src/styles/typeface.module.scss';

.popup-list-item {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas: 'icon name button';
  cursor: pointer;

  padding: {
    top: 17px;
    bottom: 17px;
  }
  align-items: center;

  .item-icon {
    grid-area: icon;
    margin-right: 10px;
  }
  .item-name {
    @include typeface('Paragraph_16_sb');
    grid-area: name;
    .item-desc {
      padding-left: 5px;
      color: var(--main);
      @include typeface('Paragraph_14_r');
    }
  }
  .item-button {
    grid-area: button;
  }
}
</style>
